module.exports = __webpack_public_path__ + "media/sòng bpai hâi láew gôr yang jà hâi doo èek.45a35024.mp3";